import React from "react"; 
 

import ContainerLandpage from "containers/Landpage";

import Topo from 'components/Landpage/Topo';
import ModosExplicacao from 'components/Landpage/ModosExplicacao';
import ComoFunciona from 'components/Landpage/ComoFunciona';
import PqAssinar from 'components/Landpage/PqAssinar';
import Planos from "components/Landpage/Planos";
import FaleConosco from "components/Landpage/FaleConosco";
import OnRodape from "components/Landpage/OnRodape";

// Componentes desativados (manter para uso futuro)
//import Banner from "components/Landpage/Banner";
//import Depoimentos from "components/Landpage/Depoimentos"; // ativar quando tiver depoimentos reais
//import RedesSociais from "components/Landpage/RedesSociais";

export default function Landpage(){

    return (
        <ContainerLandpage>

            <Topo />
            <ModosExplicacao />
            <ComoFunciona />
            <PqAssinar />
            <Planos />
            <OnRodape />
            <FaleConosco />

        </ContainerLandpage>
    );
}